var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22823 2.22588C3.22805 2.58766 3.08415 2.93456 2.82821 3.19025C2.57226 3.44595 2.22522 3.58949 1.86343 3.58931C1.50165 3.58913 1.15475 3.44524 0.899057 3.18929C0.643364 2.93334 0.499819 2.5863 0.5 2.22452C0.500181 1.86273 0.644073 1.51583 0.900022 1.26014C1.15597 1.00445 1.50301 0.860903 1.8648 0.861084C2.22658 0.861265 2.57348 1.00516 2.82917 1.26111C3.08486 1.51705 3.22841 1.86409 3.22823 2.22588ZM3.26915 4.59944H0.540924V13.1388H3.26915V4.59944ZM7.57975 4.59944H4.86516V13.1388H7.55247V8.65767C7.55247 6.16135 10.8059 5.92945 10.8059 8.65767V13.1388H13.5V7.73008C13.5 3.52179 8.68468 3.67866 7.55247 5.74529L7.57975 4.59944Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin.e413d3e4f75296c012dee5e5eb3249af.svg";